export default __webpack_public_path__ + "static/media/banner-4.800d8994.jpg";